import React, { useEffect, useState } from "react";
import { getDriverDocuments, verifyDocument } from "./api";

const statusColor = (s) => ({
  verified: "#2e7d32",
  pending: "#f9a825",
  expired: "#d32f2f",
  rejected: "#7b1fa2",
}[String(s || "").toLowerCase()] || "#607d8b");

const Chip = ({ text, color }) => (
  <span style={{
    background: color, color: "#fff", padding: "2px 8px", borderRadius: 999,
    fontSize: 12, fontWeight: 700
  }}>{text}</span>
);

export default function DriverDocumentsPanel({ driver, onBack }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState("");
  const [expiry, setExpiry] = useState(""); // YYYY-MM-DD
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true); setErr("");
    try {
      const r = await getDriverDocuments(driver.id);
      setDocs(r.items || []);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [driver?.id]);

  async function action(type, a) {
    try {
      await verifyDocument({
        driver_id: driver.id,
        type,
        action: a, // verify | reject | expire
        expiry_date: a === "verify" || a === "expire" ? (expiry || null) : null,
        note: note || null,
      });
      setNote("");
      // keep expiry unless you want to clear it:
      // setExpiry("");
      await load();
    } catch (e) {
      alert(e.message);
    }
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
        <button onClick={onBack}>← Back</button>
        <h3 style={{ margin: 0 }}>Documents • {driver.name} (#{driver.id})</h3>
      </div>

      {err && <div style={{ color: "red", marginBottom: 8 }}>{err}</div>}
      {loading && <div>Loading…</div>}

      <div style={{ display: "grid", gap: 12 }}>
        {docs.map(d => (
          <div key={d.type} style={{
            padding: 12, border: "1px solid #eee", borderRadius: 12,
            display: "grid", gridTemplateColumns: "1fr auto", gap: 8
          }}>
            <div>
              <div style={{ fontWeight: 700 }}>{d.title}</div>
              <div style={{ marginTop: 6, display: "flex", gap: 8, alignItems: "center" }}>
                <Chip text={(d.status || "pending").toUpperCase()} color={statusColor(d.status)} />
                {d.expiry_date && <small>Expiry: {d.expiry_date}</small>}
                {d.file_url ? (
                  <a href={d.file_url} target="_blank" rel="noreferrer">View</a>
                ) : <small style={{ color: "#999" }}>No file</small>}
                {d.note && <small style={{ color: "#555" }}>Note: {d.note}</small>}
              </div>
            </div>

            <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>
              <button onClick={() => action(d.type, "verify")}>Verify</button>
              <button onClick={() => action(d.type, "reject")}>Reject</button>
              <button onClick={() => action(d.type, "expire")}>Expire</button>
            </div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: 16, padding: 12, border: "1px dashed #ddd", borderRadius: 12,
        display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap"
      }}>
        <label>Expiry (YYYY-MM-DD): <input value={expiry} onChange={(e) => setExpiry(e.target.value)} placeholder="2027-03-31" /></label>
        <label>Note: <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason / remark" /></label>
        <small style={{ color: "#777" }}>Set these, then click Verify/Reject/Expire on a document.</small>
      </div>
    </div>
  );
}
